// extracted by mini-css-extract-plugin
module.exports = {"container":"CVUploadModal_container__ga8tu","cancelIcon":"CVUploadModal_cancelIcon__g057u","chevronIcon":"CVUploadModal_chevronIcon__X8P2c"};